export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/3e665c3436182a77.png"